import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { WEB_CONTENT_WIDTH } from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userWrapper: {
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    display: 'flex',
    maxWidth: `calc(${WEB_CONTENT_WIDTH} - ${theme.spacing(2)})`,
    [theme.breakpoints.down('md')]: {
      maxWidth: `calc(100vw - ${theme.spacing(2)})`,
    },
  },

  userDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 'calc(100% - 64px)',
    minWidth: 0,
  },

  infoWrapper: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(0.25),
  },

  controlWrapper: {
    display: 'flex',
    flexShrink: 0,
    gap: theme.spacing(1),
    padding: `${theme.spacing(1)} 0`,
    alignItems: 'center',
  },
}));
